export default __webpack_public_path__ + "static/media/map404.ad56b998.png";